import reducerRegistry from '../../reducers/ReducerRegistry';
import { newsfeedReducer } from './reducers';

export { fetchNewsfeed, fetchUnreadNewsfeedCount, readNewsfeed } from './actions';
export { newsSelector, isFetchingSelector, unreadSelector } from './selectors';

reducerRegistry.register({
    newsfeed: newsfeedReducer,
});
